(function() {
  'use strict';
  window.Brume = window.Brume || {};

/**
 * Color Selector
 * Manages color variant switching for the buy page
 */

var switchColor = window.Brume.switchColor;

const colorLabels = {
  silver: 'Silver',
  white: 'Pearl white'
};

function initColorSelector() {
  const swatches = document.querySelectorAll('.color-swatch');
  const label = document.querySelector('.color-selector-label');
  if (swatches.length === 0) return;

  // Apply a swatch selection: active state, label, hidden input, slideshow.
  function selectSwatch(swatch) {
    const color = swatch.dataset.color;

    // Update active state on swatches
    swatches.forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');

    // Update label text (and the sticky bar's color, if present)
    if (label) {
      label.textContent = colorLabels[color] || color;
    }
    const stickyColor = document.getElementById('buyStickyColor');
    if (stickyColor) {
      stickyColor.textContent = colorLabels[color] || color;
    }

    // Update the hidden variant input so Add to Cart uses the selected color
    const variantInput = document.getElementById('variantId');
    if (variantInput && swatch.dataset.variantId) {
      variantInput.value = swatch.dataset.variantId;
    }

    // Switch slideshow images
    window.Brume.switchColor(color);
  }

  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => selectSwatch(swatch));
  });

  // Honor a ?variant= deep link (e.g. from the homepage carousel) so the page
  // opens with the requested color preselected instead of always defaulting to Silver.
  const requestedVariant = new URLSearchParams(window.location.search).get('variant');
  if (requestedVariant) {
    const match = Array.from(swatches).find(s => s.dataset.variantId === requestedVariant);
    if (match) selectSwatch(match);
  }
}

  window.Brume.initColorSelector = initColorSelector;
})();
